module.exports = __webpack_public_path__ + "img/Ad_Restroworld.b67a1469.png";